export const MIN_GRAPH_HEIGHT = 150;
export const TOOLBAR_HEIGHT = 40;
export const DROP_SHADOW_SPACING = 5;

export const DEFAULT_NODE_WIDTH = 165;
export const DEFAULT_NODE_HEIGHT = 32;
export const DEFAULT_NODE_SEPERATION_HORIZONTAL = 50;
export const WHEN_EXPRESSION_SPACING = 35;
export const DEFAULT_EDGE_INDENT = 30;
export const DEFAULT_FINALLLY_GROUP_PADDING = 35;
export const DEFAULT_CHAR_WIDTH = 8;
export const NODE_PADDING = 8;
export const EDGE_MARKER_WIDTH = 10;

export const NODE_ICON_WIDTH = 26;

export const NODE_SEPARATION_HORIZONTAL = 30;
export const EXPANDED_NODE_SEPARATION_HORIZONTAL = NODE_SEPARATION_HORIZONTAL + 65;
export const NODE_SEPARATION_VERTICAL = 20;

export const NODE_WIDTH = 100;
export const NODE_HEIGHT = 30;

export enum NodeType {
  WORKFLOW_NODE = 'workflow-node',
  WORKFLOW_GROUP = 'workflow-group',
  SPACER_NODE = 'spacer-node',
}

export enum DrawDesign {
  INTEGRAL_SHAPE = 'integral-shape',
  STRAIGHT = 'line',
}
